import React from 'react';

const Sample1Preview = ({ content }) => {
  return (
    <div className="font-sans text-sm p-6" style={{ fontFamily: 'Arial, sans-serif' }}>
      {/* Header */}
      <div className="text-center mb-6">
        <h1 className="text-2xl font-bold text-amber-800 mb-1">
          {content.header?.association_name || 'Community Association'}
        </h1>
        <h2 className="text-lg text-amber-600">
          {content.header?.newsletter_title || 'Newsletter'}
        </h2>
        <p className="text-sm text-gray-600">{content.header?.year || '2025'}</p>
      </div>

      {/* Leaf Decoration */}
      <div className="flex justify-center gap-2 mb-6">
        <div className="w-8 h-8 bg-amber-500 rounded-full opacity-80" />
        <div className="w-8 h-8 bg-orange-600 rounded-full opacity-80" />
        <div className="w-8 h-8 bg-red-600 rounded-full opacity-80" />
        <div className="w-8 h-8 bg-yellow-500 rounded-full opacity-80" />
      </div>

      {/* Two Column Layout */}
      <div className="grid grid-cols-2 gap-6">
        {/* Left Column */}
        <div className="space-y-4">
          {/* Officers */}
          <div className="bg-amber-50 p-4 rounded-lg">
            <h3 className="font-bold text-amber-800 mb-2 border-b border-amber-200 pb-1">
              {content.officers?.title || 'Officers'}
            </h3>
            <div className="space-y-1 text-sm">
              {content.officers?.list?.map((officer, index) => (
                <div key={index}>
                  <span className="text-gray-600">{officer.role}: </span>
                  <span className="font-medium">{officer.name || 'TBD'}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div className="bg-amber-50 p-4 rounded-lg">
            <h3 className="font-bold text-amber-800 mb-2 border-b border-amber-200 pb-1">
              {content.contact?.title || 'Contact Us'}
            </h3>
            <div className="space-y-1 text-sm text-gray-700">
              {content.contact?.email && <p>Email: {content.contact.email}</p>}
              {content.contact?.website && <p>Web: {content.contact.website}</p>}
              {content.contact?.address && <p>{content.contact.address}</p>}
            </div>
          </div>
        </div>

        {/* Right Column */}
        <div className="space-y-4">
          {/* Calendar */}
          <div className="bg-orange-50 p-4 rounded-lg">
            <h3 className="font-bold text-orange-800 mb-2 border-b border-orange-200 pb-1">
              {content.calendar?.title || 'Calendar'}
            </h3>
            <div className="space-y-2 text-sm">
              {content.calendar?.events?.length > 0 ? (
                content.calendar.events.map((event, index) => (
                  <div key={index} className="border-l-2 border-orange-400 pl-2">
                    <p className="font-medium">{event.date}</p>
                    <p className="text-gray-600">{event.title}</p>
                  </div>
                ))
              ) : (
                <p className="text-gray-500 italic">No events scheduled</p>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Footer Decoration */}
      <div className="mt-8 flex justify-center gap-2">
        <div className="w-6 h-6 bg-amber-400 rounded-full opacity-60" />
        <div className="w-6 h-6 bg-orange-500 rounded-full opacity-60" />
        <div className="w-6 h-6 bg-red-500 rounded-full opacity-60" />
      </div>
    </div>
  );
};

export default Sample1Preview;
